import { TextBold } from "@views/common/ProductDetails/common"
import React from "react"

interface ShippingTextProps {
  message: string
}

const ShippingText: React.FC<ShippingTextProps> = ({ message }) => (
  <TextBold>{message || ""}</TextBold>
)

export default ShippingText
